import { createContext, useContext } from "react";
export const NovaContext = createContext(false);

export const useNova = () => {
  return useContext(NovaContext);
};
NovaContext.displayName = "NovaContext";
